import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "task-parameters-leave_content" }, " Если выйти сейчас, данные не сохранятся ", -1)

import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from 'tir-components';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectNoSaveModal',
  props: {
  /**Изменения в проекте */
  isProjectSettingsChanged: { type: Boolean },
  /**Видимость модалки */
  visible: { type: Boolean },
},
  emits: ["toggleVisibleModal", "confirmLeave"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


/**Переходимый путь */
const pendingRoute = ref();

/**Переключение видимости окна */
const toggle = (_visible: boolean, callback?: Function) => {
  emit('toggleVisibleModal', _visible);
};

/**Подтверждение выхода */
const confirmLeave = () => {
  emit('confirmLeave');
  toggle(false);
  router.push(pendingRoute.value);
};
/**Проверка наличия изменений в форме перед переходом */
router.beforeEach((to, from, next) => {
  if (!props.isProjectSettingsChanged) {
    pendingRoute.value = to;
    toggle(true);
  } else {
    next();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    class: "task-parameters-leave",
    title: "Выйти сейчас?",
    "is-with-back": false,
    "is-visible": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (toggle(false)))
  }, {
    content: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Вернуться ")
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: confirmLeave
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Выйти ")
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})